<template>
  <div class="customer-list">
    <div
      v-for="(item, index) in imageList"
      :key="index"
      class="customer-list_item"
    >
      <img :src="item" loading="lazy" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      customerTypeIndex: 0,
      customerIndex: 0,
      imageList: []
    }
  },
  created() {
    console.log("customer detail created")
    let { customerTypeIndex, customerIndex } = this.$route.query;
    // this.tabSelectIndex = this.$route.path.substr(this.$route.path.length - 1) * 1
    this.customerTypeIndex = customerTypeIndex + ""
    this.customerIndex = Number(customerIndex)
    this.initData()
  },
  methods: {
    initData() {
      const baseUrl = process.env.VUE_APP_PUBLIC_PATH

      fetch(baseUrl + '/customer/data.json')
        .then(response => response.json())
        .then(data => {
          let { details } = data
          this.imageList = details[this.customerTypeIndex].customers[this.customerIndex].imageList
          console.log(this.imageList, this.customerTypeIndex, this.customerIndex, "*******************88")
        })
        .catch(error => console.error('Error loading JSON:', error));
    },
  }
}
</script>
<style lang="scss" scoped>
.customer-list {
  width: 80%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: left;
  margin-top: 150px;
  .customer-list_item {
    width: 300px;
    height: 400px;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    margin-bottom: 20px;
    font-size: 24px;
    text-align: center;
    > img {
      width: 100%;
      height: 80%;
      object-fit: contain;
    }
  }
}
</style>